module.exports = __webpack_public_path__ + "img/crate.ca952b6a.png";